<template>
  <footer class="footer-section">
    <div class="section-container footer-content">
      <!-- Left: Brand -->
      <div class="footer-brand">
        <div class="footer-logo"></div>
        <div class="brand-info">
          <div class="brand-name">必诺科技</div>
          <div class="brand-en">Binuo Technology Co., Ltd.</div>
        </div>
      </div>

      <!-- Center: Contact -->
      <div class="footer-contact">
        <div class="footer-label">联系方式</div>
        <div class="contact-list">
          <div class="contact-item">联系电话：0757-88350998</div>
          <div class="contact-item">商务合作：jf@ibinuo.com</div>
          <div class="contact-item">公司地址：广东省佛山市南海区佛平二路112号东峻大厦908室</div>
        </div>
      </div>

      <!-- Right: QR Code -->
      <div class="footer-qr-section">
        <div class="footer-label">微信公众号</div>
        <div class="footer-qr"></div>
      </div>
    </div>
    
    <div class="footer-bottom">
      <div class="copyright">©佛山市必诺科技有限公司</div>
      <div class="icp">粤ICP备20065649号-1</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style lang="scss" scoped>
.footer-section {
  background: #1F2329;
  color: #ffffff;
  padding: 60px 0 20px;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 60px;
}

/* Left: Brand */
.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer-logo {
  width: 60px;
  height: 60px;
  background-image: url('~@/assets/images/home/footer-logo.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 15px;
  margin-left: 10px;
}

.brand-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.brand-name {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 1px;
}

.brand-en {
  font-size: 12px;
  opacity: 0.6;
  font-weight: 300;
}

/* Center: Contact */
.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-label {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
  color: rgba(255, 255, 255, 0.9);
}

.contact-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

/* Right: QR Code */
.footer-qr-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;
}

.footer-qr {
  width: 100px;
  height: 100px;
  background-image: url('~@/assets/images/home/footer-qr.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  padding: 5px;
  border-radius: 4px;
}

/* Bottom */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
}

.copyright, .icp {
  line-height: 1.5;
}
</style>